import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class BoToastrService {
    constructor(
        private _toastr: ToastrService,
        private _translate: TranslateService
    ) {}
    public success(message: string) {
        this._toastr.success(message);
    }
    public successCode(code: string) {
        this._translate.get(code).subscribe((res) => {
            this._toastr.success(res);
        });
    }
    public errorCode(code: string) {
        this._translate.get(code).subscribe((res) => {
            this._toastr.error(res);
        });
    }
    public error(message: string) {
        this._toastr.error(message);
    }
    public errors(msgs: string[]) {
        if(!msgs || !msgs.length) {
            return;
        }
        msgs.forEach((msg) => {
            this._toastr.error(msg);
        });
    }
}